function convertDateFormat(inputDate) {
  const dateObject = new Date(inputDate);

  // ✅ Check if the date is invalid
  if (isNaN(dateObject.getTime())) {
    return "";
  }

  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const locale = "en-GB";

  const formattedDate = dateObject.toLocaleDateString(locale, options);
  return formattedDate;
}

export { convertDateFormat };
